import { CountryMetadata, StateMetadata } from '@b2b/types/core';
import angular, { IPromise, IQService } from 'angular';
import { ApiService } from '../api/types';

export class LocationService {
  static $inject = ['$q', 'ApiService'];
  private countriesCache: CountryMetadata[] = [];
  private statesCache: Record<CountryMetadata['alpha2Code'], StateMetadata[]> = {};
  private countries: CountryMetadata[] = [];
  private states: StateMetadata[] = [];

  constructor(private $q: IQService, private apiService: ApiService) {}

  fetchCountriesMetadata(): IPromise<CountryMetadata[]> {
    if (this.countriesCache.length > 0) {
      return this.$q.resolve(this.countriesCache);
    }

    return this.apiService.form.avs.countries().then((response) => {
      this.countriesCache = response.data.payload.slice();
      this.countries = response.data.payload;
      return response.data.payload;
    });
  }

  fetchStatesMetadata(props: { country: CountryMetadata['alpha2Code'] }): IPromise<StateMetadata[]> {
    if (this.statesCache[props.country] && this.statesCache[props.country].length > 0) {
      return this.$q.resolve(this.statesCache[props.country]);
    }

    return this.apiService.form.states.list(props).then((response) => {
      this.statesCache[props.country] = response.data.payload.slice();
      this.states = response.data.payload;
      return response.data.payload;
    });
  }

  getCountries() {
    return this.countries;
  }

  getStates() {
    return this.states;
  }

  findCountry(item: { country: string | undefined }) {
    for (let i = 0, ii = this.countries.length; i < ii; i++) {
      if (
        this.countries[i].name.toLowerCase() === item.country?.toLowerCase() ||
        this.countries[i].alpha2Code === item.country ||
        this.countries[i].alpha3Code === item.country
      ) {
        return {
          index: i,
          country: this.countries[i],
        };
      }
    }

    return undefined;
  }

  findState(item: { state: string | undefined }) {
    if (item && item.state && this.states.length) {
      return this.states.find((state) => {
        return (
          item.state?.toLowerCase() === state.abbreviation.toLowerCase() ||
          item.state?.toLowerCase() === state.name.toLowerCase()
        );
      });
    }

    return undefined;
  }
}

export const LocationServiceModule = angular
  .module('acme.common.service.location', ['acme.common.service.api'])
  .service('LocationService', LocationService).name;
